export const QUERY_REQUEST = 'QUERY_REQUEST';
export const MUTATION_REQUEST = 'MUTATION_REQUEST';
export const QUERY_FAILURE = 'QUERY_FAILURE';
export const MUTATION_FAILURE = 'MUTATION_FAILURE';
export const QUERY_CONDOLENCES_SUCCESS = 'QUERY_CONDOLENCES_SUCCESS';
export const MUTATE_CONDOLENCE_SUCCESS = 'MUTATE_CONDOLENCE_SUCCESS';
export const MUTATE_PERSON_ALERT_SUCCESS = 'MUTATE_PERSON_ALERT_SUCCESS';
export const MUTATE_PERSON_ALERT_FAILURE = 'MUTATE_PERSON_ALERT_FAILURE';
export const RESET_MUTATION_STATUS = 'RESET_MUTATION_STATUS';
export const QUERY_GALLERY_SUCCESS = 'QUERY_GALLERY_SUCCESS';
export const QUERY_LOCATION_SEARCH_SUCCESS = 'QUERY_LOCATION_SEARCH_SUCCESS';
export const MUTATE_PERSON_UGC_SUCCESS = 'MUTATE_PERSON_UGC_SUCCESS';
export const MUTATE_PERSON_UGC_FAILURE = 'MUTATE_PERSON_UGC_FAILURE';
export const MUTATE_LIKES_SUCCESS = 'MUTATE_LIKES_SUCCESS';
export const MUTATE_LIKES_FAILURE = 'MUTATE_LIKES_FAILURE';
export const PLANNING_TOKEN_EXISTS = 'PLANNING_TOKEN_EXISTS';
export const SET_TAB_INDEX = 'SET_TAB_INDEX';
export const AD_SERVICE = 'AD_SERVICE';
export const AFFILIATE_STORE = 'AFFILIATE_STORE';
export const FOOTER_STORE = 'FOOTER_STORE';
export const FUNERAL_HOME_STORE = 'FUNERAL_HOME_STORE';
export const NEARBY_FUNERAL_HOMES_STORE = 'NEARBY_FUNERAL_HOMES_STORE';
export const HEADER_STORE = 'HEADER_STORE';
export const OBITUARIES_REQUEST = 'OBITUARIES_REQUEST';
export const OBITUARIES_SUCCESS = 'OBITUARIES_SUCCESS';
export const OBITUARIES_ERROR = 'OBITUARIES_ERROR';
export const UPCOMING_SERVICES_STORE = 'UPCOMING_SERVICES_STORE';
export const ERROR = 'ERROR';
export const MOBILE_DETAILS = 'MOBILE_DETAILS';
export const SEARCH_FUNERAL_HOMES = 'SEARCH_FUNERAL_HOMES';
export const PERSON_STORE_HYDRATION = 'PERSON_STORE_HYDRATION';

/**
 * Creates an action that sets the `loading` flag to `true` upon query start
 * @method queryRequest
 * @return {object} the action object
 */
export function queryRequest() {
  return {type: QUERY_REQUEST};
}

/**
 * Creates an action that sets the `loading` flag to `true` upon mutation start
 * @method mutationRequest
 * @return {object} the action object
 */
export function mutationRequest() {
  return {type: MUTATION_REQUEST};
}

/**
 * Creates an action that sets the `loading` flag to `false`
 * and passes the reason for query failure to the reducer
 * @method queryFailure
 * @param  {object} reason the reason for failure
 * @return {object} the action object
 */
export function queryFailure(reason) {
  return {
    type: QUERY_FAILURE,
    reason,
  };
}

/**
 * Creates an action that sets the `loading` flag to `false`
 * and passes the reason for mutation failure to the reducer
 * @method mutationFailure
 * @param  {object} reason - the reason for the mutation failure
 * @return {object} the action object
 */
export function mutationFailure(reason) {
  return {
    type: MUTATION_FAILURE,
    reason,
  };
}

/**
 * Creates an action that reduces the condolence query response
 * @method queryCondolencesSuccess
 * @param  {object} response - the addditional condolences
 * @return {object} the action object with the condolence query response
 */
export function queryCondolencesSuccess(response) {
  return {
    type: QUERY_CONDOLENCES_SUCCESS,
    response,
  };
}

/**
 * Creates an action that reduces the gallery query reponse
 * @method queryGallerySuccess
 * @param  {object} response - the additional gallery condolences
 * @return {object} the action object with the galley condolence response
 */
export function queryGallerySuccess(response) {
  return {
    type: QUERY_GALLERY_SUCCESS,
    response,
  };
}

/**
 * Creates an action that reduces the condolence mutation response
 * @method mutateCondolenceSuccess
 * @param  {object} response - the response for successful mutation
 * @return {object} the action object with the condolence mutation response
 */
export function mutateCondolenceSuccess(response) {
  return {
    type: MUTATE_CONDOLENCE_SUCCESS,
    response,
  };
}

/**
 * Creates an action that reduces the person alert response
 * @method mutatePersonAlertSuccess
 * @param  {object} response - the alertId from the successful mutation
 * @return {object} the action object with the person alert mutation response
 */
export function mutatePersonAlertSuccess(response) {
  return {
    type: MUTATE_PERSON_ALERT_SUCCESS,
    response,
  };
}

/**
 * Creates an action that reduces the person alert falure response
 * @method mutatePersonAlertFailure
 * @param  {object} reason - the reason for failure
 * @return {object} the action object with the person alert mutation mutation
 */
export function mutatePersonAlertFailure(reason) {
  return {
    type: MUTATE_PERSON_ALERT_FAILURE,
    reason,
  };
}

/**
 * Creates an action that will reset the mutation status
 * @method resetMutationStatus
 * @return {object} the action object with the condolence mutation response
 */
export function resetMutationStatus() {
  return {type: RESET_MUTATION_STATUS};
}

/**
 * Creates an action that will fetch location results
 * @param  {object} response the location response from query
 * @return {object}          the action object with the location search query
 */
export function queryLocationSearchSuccess(response) {
  return {
    type: QUERY_LOCATION_SEARCH_SUCCESS,
    response,
  };
}

/**
 * Creates an action for a UGC write success
 * @param  {object} response the id of the newly inserted UGC data
 * @return {object}          the action object with the UGC success response
 */
export function mutatePersonUGCSuccess(response) {
  return {
    type: MUTATE_PERSON_UGC_SUCCESS,
    response,
  };
}

/**
 * Creates an action for a UGC write failure
 * @param  {object} reason   the reason for failure
 * @return {object}          the action object with the UGC failure reason
 */
export function mutatePersonUGCFailure(reason) {
  return {
    type: MUTATE_PERSON_UGC_FAILURE,
    reason,
  };
}

/**
 * Creates an action for a LIKES write success
 * @param  {object} response the id and new likes count
 * @return {object}          the action object with the likes success response
 */
export function mutateCondolenceLikesSuccess(response) {
  return {
    type: MUTATE_LIKES_SUCCESS,
    response,
  };
}

/**
 * Creates an action for a LIKES write failure
 * @param  {object} reason   the reason for failure
 * @return {object}          the action object with the likes failure reason
 */
export function mutateCondolenceLikesFailure(reason) {
  return {
    type: MUTATE_LIKES_FAILURE,
    reason,
  };
}

/**
 * Creates an action for updating whether the user came in via planning
 * @param  {object} planningExists  the planning token
 * @return {object}                 the action object with the planningTokenBoolean
 */
export function isFromPlanning(planningExists) {
  return {
    type: PLANNING_TOKEN_EXISTS,
    planningExists,
  };
}

/**
 * Creates an action to update the tab index
 * @param  {object} tab        the tab index
 * @return {object}            the action object with the tabIndexNumber
 */
export function setTabIndex(tab) {
  return {
    type: SET_TAB_INDEX,
    tab,
  };
}



// WEBPACK FOOTER //
// ./src/reactModules/redux/actions.js